<template>
	<div>
		<buttonlist @help="help" @search="search" @exps="exps" ref="SetBtn"></buttonlist>
		<div style="display: flex">
			<div style="width:40%;padding:5px">
				<el-table
					:data="dataTable"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="150"
					header-row-class-name="headerclass"
					style="width: 100%; margin-top:0px"
					ref="singleTable"
				>
					<el-table-column show-overflow-tooltip prop="code" :label="$t('getapi[6055]')" width="200"></el-table-column>
					<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[6056]')" width="200"></el-table-column>
				</el-table>
			</div>
			<div style="padding:5px">
				<el-row style="display: flex;background: white">
					<el-col style="text-align: right">
						<span style="padding:0 20px;">{{$t('getapi[6067]')}}</span>
						<el-select filterable v-model="changeValue" size="mini" style="margin-righ:20px" @change="changeType">
							<el-option v-for="item in changeTypeArr" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
						</el-select>
					</el-col>
				</el-row>
			</div>
		</div>
		<div id="xpane-0">
		<vxe-table
			header-row-class-name="headerclass"
			stripe
			:data="dataSetArray"
			show-overflow="tooltip"
			:auto-resize="true"
			v-loading="loading"
			resizable
			border
			:height="tableHeight"
			size="mini"
			:highlight-current-row="true"
			style="width: 100%; margin-top: 5px"
			ref="singleTable1"
		>
			<vxe-table-column v-for="item in returnHeadArray" :key="item.ColumnsField" :field="item.ColumnsField" :title="item.ColumnsName"></vxe-table-column>
		</vxe-table>
		</div>
		<!--<el-table
                :data="dataSet"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="host_name" :label="$t('getapi[6066]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="ip_address" :label="$t('getapi[345]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="employee_name" :label="$t('getapi[869]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="objecttype" :label="$t('getapi[6067]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="operation_name" :label="$t('getapi[6048]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="operation_content" :label="$t('getapi[6068]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" :label="$t('getapi[350]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" :label="$t('getapi[351]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" :label="$t('getapi[149]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" :label="$t('getapi[112]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" label="C3">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" label="C4">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="file_no" :label="$t('getapi[496]')">
            </el-table-column>
            <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
                </template>
            </el-table-column>
        </el-table>-->

		<serce :isVisible="isVisible" queryData="SysTableTraceViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'trace',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-290
        }
    },
	data() {
		return {
			dataSet: [],
			changeValue: '',
			objectType: '',
			changeTypeArr: [],
			dataTable: [],
			isVisible: false,
			queryData: [], // 查询数组
			userData: [], // 用户信息
			user: '',
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 50, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			dataSetArray: [],
			returnHeadArray: {},
			loading: false, // 加载状态
            scrollTop:0,
            scrollTop1:0,
		};
	},
    watch: {
        dataSetArray: function () {
            let that = this
            that.$nextTick(function () {
                setTimeout(() => {
                    that.$processdata.initForm(0)
                }, 500);
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.user = that.userData.username;
		that.token = that.userData.token;
		$.ajax({
			url: Common.Url + '/Sys/Currency/SysTableTraceDropList?token=' + that.token,
			type: 'post',
			async: false,
			contentType: 'application/json',
			success: function(res) {
				if (res.Success == 1) {
					that.changeTypeArr = res.DataContent;
				} else {
					//Message.error(res.Msg);
				}
			},
			error: function(xhr, errorType, error) {}
		});
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6054]"),this.$t("getapi[12]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.authority('plv2', 246, 1) == 2) {
				that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			}
		},
		search() {
			let that = this;
			if (that.objectType == '') {
				return that.$message.error(that.$t('getapi[8831]'));//'请选择修改类型！'
			}
			that.isVisible = true;
			if (that.objectType == 'v_eng_bomaction_history')
			{
				//BBOM替换历史一览
				that.$refs.ser.clearInput(that.isVisible, 'EngBOMActionHistoryViewInfo');
			}
			else if(that.objectType == 'v_eng_part_history'){
				//物料不可用设置历史记录
				that.$refs.ser.clearInput(that.isVisible, 'EngPartHistory');
			}
			else{
				that.$refs.ser.clearInput(that.isVisible, 'SysTableTraceViewInfo');
			}
		},
		//获取查询条件
		serclick(val) {			
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
			that.isVisible = false;
			that.getView();
		},
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				Type: that.objectType,
				Param: datac,
                LangType:that.$processdata.getLang(),
                fromname: that.$t('getapi[72]')
			};
            if (that.objectType == 'v_eng_bomaction_history')
            {
                parm.fromname = that.$t('getapi[72]')
            }
            else if(that.objectType == 'v_eng_part_history'){
                parm.fromname = that.$t('getapi[493]')
            }
            else{
                parm.fromname = that.$t('getapi[6054]')
            }
			that.$http.urlpost('/Sys/Currency/SysTableTracExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
		changeType(val) {
			let that = this;
			let data = {
				Code: val
			};
			that.$http.urlpost('/Sys/Currency/SysTableQueryByDropName', data, function(res) {
				if (res.Success == 1) {
					that.dataTable = res.DataContent.DataList;
					if (res.DataContent.objectType.length > 0) {
						that.objectType = res.DataContent.objectType[0].objectType;
					}
				}
			});
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				Type: that.objectType,
				Param: datac
			};
			that.$http.urlpost('/Sys/Currency/SysTableTracList', data, function(res) {
				if (res.Success == 1) {
					that.returnHeadArray = res.DataContent.HeaderList;
					that.dataSetArray = res.DataContent.DataList;
				}
                that.loading = false;
				that.authority();
			});
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
